import { useState, useEffect } from 'react'
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale/ko'
import { Box } from '@mui/material';
import Icon_Calender from '@mui/icons-material/CalendarTodayOutlined';
import { usePromoresultStore } from 'src/stores/PromoStore';

//DatePickerCustom
//DatePicker 컴포넌트

//작동에는 문제가 없으나 포커스 에러로그가 출력되는 현상이 있음 -> 수정필요함

const safeToDate = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  return typeof value === 'string' ? new Date(value) : value;
};

interface Props {
  dateProps? : string | undefined;
}

const DatePickerPromoResult = ({dateProps}:Props) => {
  const start_date = usePromoresultStore((state)=>state.visit_date)
  const setField = usePromoresultStore((state)=>state.setField)
  const [startDate, setStartDate] = useState<Date | null>(dateProps ? safeToDate(dateProps) : safeToDate(start_date));
  const [open,setOpen] = useState(false)

  useEffect(() => {
    setField('visit_date',startDate)
  }, [startDate]);

  const handleStart = (newValue: Date | null) => {
    setStartDate(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
      <Box display="flex" alignItems="center" gap="5px">
        <DatePicker
          open={open}
          onOpen={()=>setOpen(true)}
          onClose={()=>setOpen(false)}
          value={startDate}
          onChange={handleStart}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              //박스크기 스타일조정
              sx: {
                height:46,
                width:'100%',
                '& .MuiInputBase-root': {
                  height: 46,
                },
                // ✅ 포커스 시 테두리 색상 커스터마이징
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#39B95B',
                  borderWidth: '2px',
                },
              },
              //내부 이미지 조정
              InputProps: {
                endAdornment: (
                  <Icon_Calender sx={{color:'#969696'}}/>
                ),
                onClick:()=>setOpen(true)
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default DatePickerPromoResult